var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrillBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8022 10.1772C15.812 10.3405 15.787 10.504 15.729 10.657C15.6709 10.81 15.5811 10.9489 15.4654 11.0646C15.3497 11.1803 15.2107 11.2702 15.0578 11.3282C14.9048 11.3863 14.7412 11.4112 14.5779 11.4014H3.55849C3.23689 11.4014 2.91845 11.3381 2.62135 11.215C2.32424 11.0919 2.0543 10.9115 1.82693 10.684C1.59955 10.4566 1.41921 10.1866 1.2962 9.8895C1.17318 9.59236 1.10991 9.27391 1.10999 8.95232V4.05532C1.10999 3.40593 1.36795 2.78315 1.82713 2.32397C2.28632 1.86478 2.9091 1.60682 3.55849 1.60682H14.5779C14.7412 1.59701 14.9048 1.62196 15.0578 1.68001C15.2107 1.73807 15.3497 1.82791 15.4654 1.94361C15.5811 2.05931 15.6709 2.19823 15.729 2.35121C15.787 2.50419 15.812 2.66774 15.8022 2.83107V10.1772Z",
    stroke: "#003082",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6992 6.50439H25.5962",
    stroke: "#003082",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8021 4.05518H19.4749C19.7996 4.05518 20.111 4.18416 20.3405 4.41375C20.5701 4.64334 20.6991 4.95473 20.6991 5.27943V7.72793C20.6991 8.05262 20.5701 8.36401 20.3405 8.5936C20.111 8.82319 19.7996 8.95218 19.4749 8.95218H15.8021",
    stroke: "#003082",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78273 11.4014L2.33423 21.1954",
    stroke: "#003082",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3532 11.4014V15.0741C13.363 15.2374 13.338 15.401 13.28 15.554C13.2219 15.707 13.1321 15.8459 13.0164 15.9616C12.9007 16.0773 12.7618 16.1671 12.6088 16.2252C12.4558 16.2832 12.2923 16.3082 12.1289 16.2984H8.45618",
    stroke: "#003082",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23181 21.1959L9.68031 11.4019",
    stroke: "#003082",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78274 26.0935C4.29793 26.1024 3.81631 26.0135 3.36666 25.832C2.917 25.6505 2.50855 25.3803 2.16571 25.0374C1.82287 24.6945 1.55268 24.286 1.37129 23.8363C1.1899 23.3866 1.10103 22.905 1.10999 22.4202C1.10018 22.2568 1.12513 22.0933 1.18319 21.9403C1.24124 21.7873 1.33109 21.6484 1.44678 21.5327C1.56248 21.417 1.70141 21.3272 1.85438 21.2691C2.00736 21.2111 2.17091 21.1861 2.33424 21.1959H10.9046C11.0679 21.1861 11.2315 21.2111 11.3844 21.2691C11.5374 21.3272 11.6763 21.417 11.792 21.5327C11.9077 21.6484 11.9976 21.7873 12.0556 21.9403C12.1137 22.0933 12.1386 22.2568 12.1288 22.4202V24.8687C12.1386 25.032 12.1137 25.1956 12.0556 25.3485C11.9976 25.5015 11.9077 25.6404 11.792 25.7561C11.6763 25.8718 11.5374 25.9617 11.3844 26.0197C11.2315 26.0778 11.0679 26.1027 10.9046 26.0929L4.78274 26.0935Z",
    stroke: "#003082",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrillBlue);
export default __webpack_public_path__ + "static/media/drillBlue.cad0a4fe2050f6e52a76998f827dda39.svg";
export { ForwardRef as ReactComponent };